import React, { useState, useEffect } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import ProcedurePatient from './ProcedureList';

export default function ProcedurePatientList(props)
{
    //GROUP
    const objproc = [];
    props.pdata.forEach(element => {
        if (objproc[element.HabCirugia]===undefined)
        {
            objproc[element.HabCirugia] = [];
            objproc[element.HabCirugia].push(element);
        } else {
            objproc[element.HabCirugia].push(element);
        }
    });
    //ARRAY
    const procedures = [];
    for(var p in objproc) {
        procedures.push(objproc[p]);
     }
    //SORT
    procedures.sort(function(a, b) {
        if (a[0].HabCirugia > b[0].HabCirugia) {
        return 1;} else if (a[0].HabCirugia < b[0].HabCirugia) {
        return -1 } else { return 0; }
    });
    //COMPONENT
    var listProc = procedures.map((proc, index) => 
        <ProcedureList active={props.active?'1':'0'} 
                Pacientes={proc}
                Tipo={proc[0].HabCirugia}
                key={index}/>
    );

    return(
        <section className="p8">
            <div>{listProc}</div>
        </section>
    );
}

function ProcedureList(props)
{
    const [isopen, setIsopen] = useState(props.active);

    useEffect(() => {
        setIsopen(props.active);
    },[props.active]);

    const objpatients = props.Pacientes;
    const patients = [];
    for(var p in objpatients) {
        patients.push(objpatients[p]);
     }

     patients.sort(function(a, b) {
        if (a.Fullname > b.Fullname) {
        return 1; } else if (a.Fullname < b.Fullname) {
        return -1 } else { return 0; }
    });

    const listPatients = patients.map((patient,index) =>
        <ProcedurePatient {...patient} key={index}/>
    );

    if (patients.length>0)
    {
        return(
            <Accordion activeKey={isopen} style={{marginBottom:'8px'}}>
                <Card border="primary">
                    <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => setIsopen(isopen==='1'?'0':'1')}>
                        <Row className="mr-0 ml-0">
                            <Col>
                                <span className='purple'><strong>{props.Tipo}</strong></span>
                                <span>&#8195;</span>
                                <span><strong>{props.Pacientes.length}</strong></span>
                                <span> Cirugia(s)</span>
                                <span>&#8195;</span>
                                <span className="alright hover_pointer">
                                    <FontAwesomeIcon className="fsp24 vac blue" icon={faAngleDown}/>
                                </span>
                            </Col>
                        </Row>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                        <div>
                        {listPatients}
                        </div>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
            );
    } else {
        return(<></>);
    }
}